"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValueInfo = void 0;
var ValueInfo = (function () {
    function ValueInfo(unit, value) {
        if (unit === void 0) { unit = ''; }
        this.unit = unit;
        this.isValidNumber = value !== undefined;
        if (this.isValidNumber)
            this.value = value;
    }
    Object.defineProperty(ValueInfo.prototype, "isEmpty", {
        get: function () { return this.equals(ValueInfo.empty); },
        enumerable: false,
        configurable: true
    });
    ValueInfo.prototype.equals = function (obj) {
        return obj &&
            obj.isValidNumber == this.isValidNumber &&
            obj.value == this.value &&
            obj.unit == this.unit;
    };
    ValueInfo.empty = new ValueInfo();
    return ValueInfo;
}());
exports.ValueInfo = ValueInfo;
